import { type Image } from '@/interfaces';

export const broknByYouMainImages: ReadonlyArray<Image> = Object.freeze([
  {
    altText: 'images.altText.stoneGreen',
    imageDirectoryPath: 'brokn-by-you-green-stone',
    extension: 'jpg',
    width: 768,
    height: 512,
    contents: [{ title: 'broknByYou.mainSection.title', text: 'broknByYou.mainSection.content' }],
    animation: 'fade-right'
  },
  {
    altText: 'images.altText.stoneYellow',
    imageDirectoryPath: 'brokn-by-you-yellow-stone',
    extension: 'jpg',
    width: 1270,
    height: 847,
    contents: [{ title: 'broknByYou.mainSection.title2', text: 'broknByYou.mainSection.content2' }],
    animation: 'fade-left'
  }
]);

export const broknByYouMainSectionGridImages: ReadonlyArray<Image> = Object.freeze([
  {
    imageDirectoryPath: 'brokn-by-you-croped-left',
    extension: 'jpg',
    altText: 'images.altText.ring',
    width: 1672,
    height: 2067
  },
  {
    imageDirectoryPath: 'brokn-by-you-croped-right',
    extension: 'jpg',
    altText: 'images.altText.ring',
    width: 1671,
    height: 2654
  },
  {
    imageDirectoryPath: 'brokn-by-you-croped-center',
    extension: 'jpg',
    altText: 'images.altText.ring',
    width: 1671,
    height: 2652
  }
]);
